"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseOptions = void 0;
var constants_1 = require("./constants");
var parseOptions = function (options) {
    // default values
    var difference = constants_1.DEFAULT_DIFFERENCE;
    var considerations = constants_1.DEFAULT_CONSIDERATIONS;
    var brightness = constants_1.DEFAULT_BRIGHTNESS;
    if ((options === null || options === void 0 ? void 0 : options.difference) !== undefined)
        difference = options.difference;
    if ((options === null || options === void 0 ? void 0 : options.considerations) !== undefined)
        considerations = options.considerations;
    if ((options === null || options === void 0 ? void 0 : options.brightness) !== undefined)
        brightness = options.brightness;
    return {
        difference: difference,
        considerations: considerations,
        brightness: brightness
    };
};
exports.parseOptions = parseOptions;
